import styled from "styled-components";
import {OnboardingDialogDefaultBox} from "./onboarding-dialog.default.box";
import {hexToRgba} from "../../../../../themes/hex-to-rgba";

export const OnboardingDialog888CasinoBox = styled(OnboardingDialogDefaultBox)`
    box-shadow: 0 2px 10px 0 ${({theme}) => hexToRgba(theme.colors.backgroundContrast, 0.16) };
`;